<label class="container cursor-pointer" role="checkbox">
  <input [tabindex]="tabIndex" [attr.aria-label]="ariaLabel" role="checkbox" type="checkbox" [checked]="checked" (keyup.enter)="onChange(!checked)">
  <span class="checkmark background-transparent br-2"></span>
</label>